module.exports = __webpack_public_path__ + "static/media/nivaLogo.399496c7.jpeg";